<template>
  <div class="pc-class">
    <Layout>
      <!-- PC版Header 開始 -->
      <!-- v-if="!isPhone" -->
      <Header>
        <div class="header-area">
          <Row type="flex" class="top-line" justify="center" align="middle">
            <Col>
              <div @click="toIndex()" class="header-logo">
                <Row type="flex" align="middle" style="flex-wrap: nowrap;">
                  <Col>
                    <div class="logo-box">
                      <img :src="logo" class="logo" />
                    </div>
                  </Col>
                  <Col>
                    <div class="logo-text">
                      Golden River<br><span class="logo-sub-text">International Corporation</span>
                    </div>
                  </Col>
                </Row>
              </div
            ></Col>
            <!--手機版 語言選單  開始-->
            <Col
              v-if="isPhone"
              :xs="{ span: 3, offset: 7 }"
              :sm="{ span: 3, offset: 7 }"
              :md="{ span: 1, offset: 5 }"
              :lg="{ span: 1, offset: 5 }"
            >
              <div class="menu-lang" v-if="isPhone">
                <img
                  class="currentLang"
                  :src="langImg()"
                  @click="langSelect = !langSelect"
                />
                <div class="select-lang" v-if="langSelect">
                  <div
                    class="lang-block"
                    v-for="(item, index) in langList"
                    :key="index"
                    @click="langChange(item)"
                  >
                    <img class="lang-logo" :src="item.img" />
                    <div class="lang-name">{{ item.name }}</div>
                  </div>
                </div>
              </div>
              <!-- <Select @on-change="langChange" v-model="$i18n.locale">
                    <Option
                        :key="index"
                        v-for="(item, index) in locale"
                        :label="item"
                        :value="index">
                    </Option>
                  </Select> -->
            </Col>
            <!--手機版 語言選單  結束-->
            <!--手機版 聯絡按鈕  開始-->
            <Col :xs="3" :sm="3" :md="1" :lg="1" v-if="isPhone">
              <div class="contact-block" @click="openModal()">
                <!-- <div class="contact-btn"></div> -->
                <img
                  class="contact-btn"
                  :src="getDefaultBtn()"
                  @mouseover="isHover = true"
                  @mouseleave="isHover = false"
                />
              </div>
            </Col>
            <!-- 手機版 聯絡按鈕  結束-->
            <!-- sideBar按鈕  開始-->
            <Col :xs="3" :sm="3" :md="2" :lg="2" v-if="isPhone">
              <nav class="main-nav">
                <Burger></Burger>
              </nav>
            </Col>
            <!-- sideBar按鈕  結束-->
          </Row>
          <Sidebar>
            <Menu
              ref="sideMenuMb"
              theme="dark"
              mode="vertical"
              accordion
              width="100%"
              :style="{align: 'center'}"
              @on-select="handleSelect"
              :open-names="openNames"
            >
            <!-- :active-name="activeIndex" -->
              <template v-for="(item,index) in navItems">
                <template v-if="item.item.length ===1">
                  <MenuItem :key="'menu-'+index" :name="index.toString()">
                    <span :key="'span-'+index" @click="toPage(item.item[0].path)">{{$t(item.item[0].name)}}</span>
                  </MenuItem>
                </template>
                <template v-else>
                  <Submenu :ref="'submenu'+index" :key="'submenu-'+index" :name="index">
                      <template slot="title">
                          <span>{{$t(item.name)}}</span>
                      </template>
                      <template v-for="(subItem,subIndex) in item.item">
                        <MenuItem :key="'sub-menu-'+subIndex" :name="index+'-'+subIndex">
                          <span :key="'span-'+subIndex">{{$t(subItem.name)}}</span>
                        </MenuItem>
                      </template>
                  </Submenu>
                </template>
              </template>
            </Menu>
          </Sidebar>
          <!-- 書籤選單  開始-->
          <Row type="flex" justify="center" class="second-line" ref="headerMenu" v-if="!isPhone">
            <!-- <Col span="10" offset="7"> -->
            <div class="top-menu">
              <Col
                :xs="{ span: 5, offset: 0 }"
                :sm="{ span: 5, offset: 0 }"
                :md="{ span: 5, offset: 0 }"
                :lg="{ span: 4, offset: 2 }">
                <router-link :to="'/#productArea'">
                  <div class="tag-btn">
                    {{ $t("ProductArea") }}
                  </div></router-link
                >
              </Col>
              <Col :xs="5" :sm="5" :md="5" :lg="4">
                <router-link :to="'/#aboutArea'"
                  ><div class="tag-btn">
                    {{ $t("BrandConcept") }}
                  </div></router-link
                >
              </Col>
              <Col :xs="5" :sm="5" :md="5" :lg="4">
                <router-link :to="'/#devArea'"
                  ><div class="tag-btn">
                    {{ $t("DevelopmentProcess") }}
                  </div></router-link
                >
              </Col>
              <Col :xs="5" :sm="5" :md="5" :lg="4">
                <router-link :to="'/#techArea'"
                  ><div class="tag-btn">
                    {{ $t("TechnicalSupport") }}
                  </div></router-link
                >
              </Col>
              <!--PC版 語言選單  開始-->
              <Col
                :xs="{ span: 1, offset: 0 }"
                :sm="{ span: 2, offset: 0 }"
                :md="{ span: 1, offset: 0 }"
                :lg="{ span: 1, offset: 2 }"
              >
                <!-- :xs="2" :sm="2" :md="1" :lg="1" offset="3" -->
                <div class="menu-lang">
                  <img
                    class="currentLang"
                    :src="langImg()"
                    @click="langSelect = !langSelect"
                  />
                  <div class="select-lang" v-if="langSelect">
                    <div
                      class="lang-block"
                      v-for="(item, index) in langList"
                      :key="index"
                      @click="langChange(item)"
                    >
                      <img class="lang-logo" :src="item.img" />
                      <div class="lang-name">{{ item.name }}</div>
                    </div>
                  </div>
                </div>
              </Col>
              <!--PC版 語言選單  結束-->
              <!--PC版 聯絡按鈕  開始-->
              <Col
                :xs="{ span: 1, offset: 0 }"
                :sm="{ span: 1, offset: 0 }"
                :md="{ span: 1, offset: 0 }"
                :lg="{ span: 1, offset: -2 }" >
                <div class="contact-block" @click="openModal()">
                  <!-- <div class="contact-btn"></div> -->
                  <img
                    class="contact-btn"
                    :src="getDefaultBtn()"
                    @mouseover="isHover = true"
                    @mouseleave="isHover = false"
                  />
                </div>
              </Col>
              <!--PC版 聯絡按鈕  結束-->
            </div>
            <!-- </Col> -->
            <!-- 搜尋區 暫時不使用  開始-->
            <!-- <Col span="3" push="2"> <div class="search">
                <input type="text" v-model="searchInput" value=""/><img class="search-btn" :src="iconSearch"/>
              </div>
            </Col> -->
            <!-- 搜尋區 暫時不使用  結束-->
          </Row>
          <!-- 書籤選單  結束-->
        </div>
      </Header>
      <!-- PC版Header 結束 -->
      <!-- 手機版Header 開始 -->
      <!-- <Header class="mobile-class" v-else>
        <Row type="flex" justify="space-between">
          <Col span='6' class="header-logo">
            <router-link to="/index">
              <img :src="logo">
            </router-link>
          </Col>
          <Col span='6'>
            <nav class="main-nav">
              <Burger></Burger>
            </nav>
          </Col>
        </Row>
        <Sidebar>
          <Menu
            ref="sideMenuMb"
            theme="dark"
            :active-name="activeIndex"
            mode="vertical"
            accordion
            width="300px"
            :style="{align: 'center'}"
            @on-select="handleSelect"
            :open-names="openNames"
          >
            <template v-for="(item,index) in navItems">
              <template v-if="item.item.length ===1">
                <MenuItem :key="'menu-'+index" :name="index.toString()">
                  <span :key="'span-'+index" @click="toPage(item.item[0].path)">{{$t(item.item[0].name)}}</span>
                </MenuItem>
              </template>
              <template v-else>
                <Submenu :ref="'submenu'+index" :key="'submenu-'+index" :name="index">
                    <template slot="title">
                        <span>{{$t(item.name)}}</span>
                    </template>
                    <template v-for="(subItem,subIndex) in item.item">
                      <MenuItem :key="'sub-menu-'+subIndex" :name="index+'-'+subIndex">
                        <span :key="'span-'+subIndex">{{$t(subItem.name)}}</span>
                      </MenuItem>
                    </template>
                </Submenu>
              </template>
            </template>
          </Menu>
        </Sidebar>
      </Header> -->
      <!-- 手機版Header 結束 -->
      <Layout>
        <Content class="content-wrap">
          <router-view />
        </Content>
      </Layout>
    </Layout>
    <!-- Footer 開始 -->
    <Footer>
      <div class="footer-area">
        <Row type="flex" justify="center">
          <Col
          >
            <div class="img-logo">
              <Row type="flex" align="middle" style="flex-wrap: nowrap;">
                <Col>
                  <div class="logo-box">
                    <img :src="logo" class="logo" />
                  </div>
                </Col>
                <Col>
                  <div class="logo-text">
                    Golden River<br><span class="logo-sub-text">International Corporation</span>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          <!-- <Col
            :xs="{ span: 24, offset: 0}"
            :sm="{ span: 24, offset: 0}"
            :md="{ span: 12}"
            :lg="{ span: 12}">
            <Row>
              <div class="footer-block" v-for="(item, index) in footerList" :key="index">
                <div class="footer-img">
                  <img :src="item.img"/>
                </div>
                <div class="footer-content">{{ $t(item.title) }}</div>
              </div>
            </Row>
          </Col> -->
        </Row>
        <Row>
          <Col>
            <p class="copyright-text">&copy; Copyright 2022</p>
          </Col>
        </Row>
      </div>
    </Footer>
    <!-- Footer 結束 -->
    <!-- 回到頂端的按鈕開始 (圖要記得換掉) -->
    <!-- <BackTop>
      <div :height="100" :bottom="100" :right="10">
        <img :src="arrow" class="top-img"/>
      </div>
    </BackTop> -->
    <!-- 回到頂端的按鈕結束 -->
    <Modal v-model="isModalOpen" width="400" :title="$t('contactus')">
      <div class="icon-email"><img :src="iconEmail" /></div>
      <p class="email">{{ email }}</p>
      <div slot="footer" class="modal-footer">
        <div
          class="copy-btn"
          ref="copyBtn"
          v-clipboard:copy="email"
          @click="copy()"
        >
          {{ $t("copy") }}
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import platformConfig from '@/config/PlatformConfig'
import { defaultRoute } from '@/main'
import arrow from '@/assets/pc/go_top.png'
import Burger from '@/mobile/components/Menu/Burger.vue'
import Sidebar from '@/mobile/components/Menu/Sidebar.vue'
import { mutations } from '@/util/burger' // 新menu
import logoSmall from '@/assets/common/logo/logo_small.png'
import logoLarge from '@/assets/common/logo/logo_large.png'
import iconContact from '@/assets/common/homePage/btn/btn_service_01_nor.png'
import iconContactHover from '@/assets/common/homePage/btn/btn_service_01_hover.png'
import iconSearch from '@/assets/common/homePage/btn/btn_search_01_nor.png'
import iconEmail from '@/assets/common/homePage/icon/img_email_01.png'
import langEng from '@/assets/common/flag/mb_ln_icon_en.png'
import iconAdd from '@/assets/footer/icon/icon_add_01.png'
import iconFooterEmail from '@/assets/footer/icon/icon_email_01.png'
import iconPhone from '@/assets/footer/icon/icon_phone_01.png'
import footerLogoen from '@/assets/footer/logo_01_en.png'
import footerLogocn from '@/assets/footer/logo_01_sc.png'
import footerLogotw from '@/assets/footer/logo_01_tc.png'

export default {
  components: {
    Burger,
    Sidebar
  },
  computed: {
    isPhone () {
      return navigator.userAgent.includes('Mobile')
    }
  },
  data () {
    return {
      logo: platformConfig.logo,
      allRoutes: defaultRoute[0].children,
      navItems: [],
      openNames: [],
      locale: platformConfig.locale,
      // activeIndex: '0',
      langSelect: false,
      arrow,
      isModalOpen: false,
      title: '',
      footerLogo: '',
      email: 'Contact@goldenriver.tech',
      currentLang: require('@/assets/common/flag/mb_ln_icon_en.png'),
      footerList: [
        // {
        //   img: iconPhone,
        //   title: 'phone'
        // },
        // {
        //   img: iconAdd,
        //   title: 'add'
        // },
        // {
        //   img: iconFooterEmail,
        //   title: 'email'
        // }
      ],
      langList: [
        {
          img: require('@/assets/common/flag/mb_ln_icon_tw.png'),
          name: '繁體中文',
          lang: 'tw'
        },
        {
          img: require('@/assets/common/flag/mb_ln_icon_en.png'),
          name: 'English',
          lang: 'en'
        }
      ],
      logoSmall,
      logoLarge,
      // defalutBtn: this.iconContact,
      iconContact,
      iconContactHover,
      isHover: false,
      iconSearch,
      iconEmail,
      iconAdd,
      iconFooterEmail,
      iconPhone,
      footerLogoen,
      footerLogocn,
      footerLogotw,
      searchInput: 'SEARCH',
      langEng
    }
  },
  methods: {
    closeSidebarPanel: mutations.toggleNav,
    menuInitial () {
      this.openNames = sessionStorage.getItem('activeNav') === null ? ['0'] : [sessionStorage.getItem('activeNav').substr(0, 1)]
      const emptyMenu = []
      const newMenu = []
      this.allRoutes.forEach(route => {
        const rawRouteNameArray = route.id.split('-')
        const routeName = rawRouteNameArray[0]
        console.log('routeName', routeName)
        if (newMenu.indexOf(routeName) === -1) newMenu.push(routeName)
      })
      newMenu.forEach(item => {
        emptyMenu.push({ name: item, item: [] })
      })
      this.allRoutes.forEach(routeItem => {
        const routeName = (routeItem.id.split('-')[0])
        emptyMenu.forEach((menuItem, index, thisArray) => {
          if (routeName === menuItem.name) {
            thisArray[index].item.push(routeItem)
          }
        })
      })
      this.navItems = emptyMenu
      console.log('navItems', this.navItems)
    },
    langChange (item) {
      // this.currentLang = item.img
      sessionStorage.setItem('langImg', item.img) // 儲存圖片連結
      sessionStorage.setItem('locale', item.lang) // 儲存語言
      this.$i18n.locale = item.lang // 切換語言
      this.$store.dispatch('changeLangImg') // 儲存圖片連結
      this.$store.dispatch('changeLanguage') // 儲存語言
      window.location.reload()
    },
    langImg () {
      return this.$store.state.login.langImg
        ? this.$store.state.login.langImg
        : this.langEng
      // 預設英文
    },
    initLang () {
      // 語言原始設定 預設:英文
      sessionStorage.setItem('langImg', '') // 清除圖片連結
      sessionStorage.setItem('locale', '') // 清除語言
      this.$i18n.locale = this.$store.state.login.locale
        ? this.$store.state.login.locale
        : 'en'
    },
    bannerHandler () {
      const locale = this.$store.state.login.locale ? this.$store.state.login.locale : 'en'
      switch (locale) {
        case 'en':
          this.footerLogo = this.footerLogoen
          break
        case 'tw':
          this.footerLogo = this.footerLogotw
          break
        case 'cn':
          this.footerLogo = this.footerLogocn
          break
      }
    },
    toIndex () {
      // if (!location.href.includes('index')) {
      this.$router.push('/')
      // } else {
      //   window.location.reload()
      // }
    },
    toPage (path) {
      if (path === '') {
        this.$router.push('/')
      } else {
        this.$router.push(path)
      }
    },
    openModal () {
      this.isModalOpen = true
      const e = this.$refs.copyBtn
      e.classList.remove('activeBtn')
    },
    copy () {
      console.log('copy')
      const element = this.$refs.copyBtn
      element.classList.add('activeBtn')
    },
    getDefaultBtn () {
      // contactBtn 的hover換圖片判斷
      return this.isHover ? this.iconContactHover : this.iconContact
    },
    // 手機版 方法
    handleSelect () {
      this.closeSidebarPanel()
    }
    // components: {
    //   Burger,
    //   Sidebar
    // }
  },
  mounted () {
    this.menuInitial()
    this.bannerHandler()
    this.$nextTick(() => {
      if (!this.isPhone) this.$refs.sideMenu.updateActiveName()
    })
  },
  created () {
    this.initLang()
  }
}
</script>
<style lang="scss">
// *--------------------------PC版 開始--------------------------
.pc-class {
  .ivu-layout {
    position: relative;
    /* header開始 */
    .ivu-layout-header {
      height: 129px;
      line-height: 30px;
      padding: 0px;
      .header-area {
        position: fixed;
        width: 100%;
        z-index: 500;
        .logo-box {
          width: 60px;
        }
        .logo {
          width: 100%;
          height: auto;
        }
        .logo-text {
          text-wrap: nowrap;
          white-space: nowrap;
          color: white;
          font-size: 18px;
          font-weight: bold;
          line-height: 0.8;
        }
        .logo-sub-text {
          font-size: 10px;
        }
        .top-line {
          background-color: #1e314f;
          padding: 15px 0px 5px;
          height: 86px;
          // display: flex;
          // align-items: center;
          // justify-content: center;
          .contact-block,
          .menu-lang {
            width: 30%;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            cursor: pointer;
          }
          // .header-logo {
          //   height: 66px;
          //   text-align: center;
          //   img {
          //     width: 250px;
          //   }
          // }
          .contact-block {
            img {
              width: 30px;
              height: 30px;
            }
          }
        }
        .second-line {
          height: 43px;
          background-color: #0f1d37;
          display: flex;
          justify-content: center;
          align-items: center;
          box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.4);
          .top-menu {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            .tag-btn {
              padding: 6px 0px;
              // width: 220px;
              text-align: center;
              color: #fff799;
              white-space: nowrap;
              cursor: pointer;
              height: 100%;
              background-color: #0f1e36;
              color: #fff799;
              &:hover {
                background-color: #0960d6;
                color: #f1f1f1;
              }
            }
            .contact-block,
            .menu-lang {
              // width: 30%;
              display: flex;
              justify-content: center;
              align-items: flex-start;
              text-align: center;
              cursor: pointer;
              img {
                width: 30px;
              }
            }
          }
          .search {
            display: flex;
            align-items: center;
            justify-content: end;
            background-color: #1e314f;
            border-radius: 20px;
            padding: 0px 10px;
            width: 80%;
            &:hover {
              border: solid 1.5px #0960d6;
              box-sizing: border-box;
            }
            input {
              background-color: transparent;
              border: none;
              color: #6f7e94;
              width: 80%;
              &:focus {
                border: solid 1px transparent;
                outline: none;
                color: #f1f1f1;
              }
            }
            .search-btn {
              margin-left: 2px;
            }
          }
        }
      }
      .ivu-select {
        width: 80px;
      }
      // PC&手機版 語言選單
      .menu-lang {
        // display: flex;
        // justify-content: flex-start;
        // align-items: flex-start;
        .select-lang {
          position: absolute;
          z-index: 600;
          width: 120px;
          background-color: #0f1d37;
          border-radius: 5px;
          padding: 15px 0px;
          top: 36px;
          .lang-block {
            display: flex;
            padding: 13px;
            &:hover {
              background-color: #0960d6;
              color: #fffffe;
              //  border-radius: 5px;
            }
            .lang-name {
              margin-left: 5px;
              white-space: nowrap;
              color: #fff;
            }
          }
        }
      }

      // 選單開始
      .ivu-menu-horizontal {
        .ivu-menu-item {
          color: #fff;
          &:hover {
            color: #ffac5a;
          }
        }
        .ivu-menu-item-active {
          color: #ffac5a;
        }
        .ivu-menu-submenu {
          &:hover {
            background-color: #004077;
          }
          span {
            color: #fff;
          }
          .ivu-select-dropdown {
            background-color: #004077;
            margin-top: 0;
            .ivu-menu-item {
              &:hover {
                background-color: #2563af;
              }
            }
          }
        }
      }
      // 選單結束
    }
    /* header 結束 */
    .content-wrap {
      background-color: #fff;
      min-height: 87vh;
      position: relative;
    }
  }
  /* footer 開始 */
  .ivu-layout-footer{
    padding: 10px 20px;
    .footer-area {
      padding: 20px 0px;
      .copyright-text {
        text-align: center;
      }
      .img-logo {
        .logo-box {
          width: 60px;
        }
        .logo {
          width: 100%;
          height: auto;
        }
        .logo-text {
          text-wrap: nowrap;
          color: white;
          font-size: 18px;
          font-weight: bold;
          line-height: 0.8;
        }
        .logo-sub-text {
          font-size: 10px;
        }
        // width: 80px;
        // border: solid 1px red;
        display: flex;
        img {
          width: 100%;
        }
      }
      .footer-block {
        display: flex;
        flex-direction: row;
        margin: 10px;
        }
        .footer-img {
          text-align: center;
          width: 50px;
          img {
            width: 30%;
          }
        }
        .footer-content {
          font-size: 10px;
          width: 40%;
          // white-space: normal;
          word-break: break-all;
        }
      }
    }
  /* footer 結束 */
  /* to-top按鈕開始 */
  .top-img {
    display: block;
    width: 80%;
  }
  /* to-top按鈕結束 */
  /* footer圖片 開始 */
  .img-logo {
    width: 80%;
  }
  /* footer圖片 結束 */
}
/* RWD設定 開始 */
// 手機版 開始
@media screen and (max-width: 768px) {
  // xs
  .pc-class {
    .ivu-layout {
      .ivu-layout-header {
        height: 66px;
        .header-area {
          .top-line {
            height: 66px;
            padding: 0px 0px 0px;
            // .header-logo {
            //   padding-left: 15px;
            //   display: flex;
            //   justify-content: flex-start;
            //   align-items: center;
            //   img {
            //     width: 160px;
            //   }
            // }
          }
          .second-line {
            .top-menu {
              .tag-btn {
                padding: 6px 0px;
                font-size: 10px;
                width: 150px;
              }
            }
          }
        }
        .menu-lang {
          img {
            width: 30px;
          }
          .select-lang {
            // position: absolute;
            // z-index: 600;
            // width: 120px;
            // background-color: #0f1d37;
            // border-radius: 5px;
            // padding: 15px 0px;
            top: 48px;
          }
        }
      }
    }
    /* footer 開始 */
    .ivu-layout-footer{
      .footer-area {
        padding: 10px 0px;
        .img-logo {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          padding: 0px 5%;
          margin: 15px 0px 30px;
          img {
            width: 250px;
          }
        }
        .footer-block {
          display: flex;
          flex-direction: row;
          margin: 10px;
          .footer-img {
            text-align: center;
          }
          .footer-content {
            font-size: 10px;
            width: 100%;
          }
        }
      }
    }
    /* footer 結束 */
  }
}
// 手機版 結束
@media screen and (min-width: 768px) and (max-width: 992px) {
  //sm
  .pc-class {
    .ivu-layout {
      .ivu-layout-header {
        .header-area {
          .top-line {
            padding: 12px 0px 3px;
            .header-logo {
            }
          }
          .second-line {
            .top-menu {
              .tag-btn {
                padding: 6px 0px;
                font-size: 12px;
                width: 150px;
              }
            }
          }
        }
      }
    }
     /* footer 開始 */
    .ivu-layout-footer{
      .footer-area {
        padding: 20px 0px;
        .footer-block {
          display: flex;
          flex-direction: row;
          margin: 10px;
          .footer-img {
            text-align: center;
          }
          .footer-content {
            font-size: 10px;
            width: 100%;
          }
        }
      }
    }
    /* footer 結束 */
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) { // md
  .pc-class {
    // .ivu-layout {
    //   .ivu-layout-header {
    //     .header-area {
    //       .top-line {
    //         padding: 12px 0px 3px;
    //         .header-logo {
    //           img {
    //             width: 100%;
    //           }
    //         }
    //       }
    //       .second-line {
    //         .top-menu {
    //           .tag-btn {
    //             padding: 6px 0px;
    //             font-size: 12px;
    //             width: 180px;
    //           }
    //         }
    //       }
    //     }
    //   }
    // }
     /* footer 開始 */
    .ivu-layout-footer{
      .footer-area {
        padding: 20px 0px;
        .footer-block {
          display: flex;
          flex-direction: row;
          margin: 10px;
          .footer-img {
            text-align: center;
          }
          .footer-content {
            font-size: 10px;
            width: 70%;
          }
        }
      }
    }
    /* footer 結束 */
}
// @media screen and (min-width: 768px) {
//   .pc-class {
//     .ivu-layout {
//       .content-wrap {
//         background-color: #004077;
//         min-height: 87vh;
//       }
//     }
//   }
// }
/* RWD設定 結束 */
/* 共通 開始 */
}
.activeBtn {
  background-color: #003c8e;
  color: #fff799;
}
.menuShadow {
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.4);
}
.contactHover {
  background-image: url("~@/assets/common/homePage/btn/btn_service_01_hover.png");
}
/* 共通 結束 */
</style>
<style lang="scss">
/* Modal設定 開始 */
.ivu-modal {
  font-family: "Noto Sans TC", "Noto Sans SC", "Noto Sans", sans-serif;
  .ivu-modal-close .ivu-icon-ios-close {
    font-size: 31px;
    color: #000;
    transition: color 0.2s ease;
    position: relative;
    font-weight: 800;
    top: 1px;
    &:hover {
      color: #0960d6;
    }
  }
  .ivu-modal-header {
    border-bottom: solid 1px #fff;
    padding: 14px 16px;
    line-height: 1;
    .ivu-modal-header-inner {
      display: inline-block;
      width: 100%;
      height: 20px;
      line-height: 20px;
      font-size: 16px;
      color: #3c4e8c;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
    }
  }
  .ivu-modal-footer {
    border-top: solid 1px #fff;
    padding: 12px 18px 12px 18px;
    text-align: right;
  }
}
.icon-email {
  text-align: center;
  margin: 20px 0px;
}
.email {
  text-align: center;
  color: #3c4e8c;
}
.modal-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  .copy-btn {
    background-color: #0f1d37;
    color: #fff799;
    border-radius: 5px;
    // width: 50px;
    text-align: center;
    cursor: pointer;
    padding: 10px 40px;
    &:hover {
      background-color: #0960d6;
      color: #f1f1f1;
    }
  }
}
/* 共通 開始 */
.activeBtn {
  background-color: #003c8e !important;
  color: #fff799;
}
/* 共通 結束 */
/* Modal設定 結束 */
</style>
